/**
 * BookableResourceBlockoutTypeService
 * Service for managing bookable resource blockout types
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for bookable resource blockout type CRUD operations
 */
export class BookableResourceBlockoutTypeService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? BookableResourceBlockoutTypeService.DEFAULT_SERVICE_PATH,
            basePath: BookableResourceBlockoutTypeService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
BookableResourceBlockoutTypeService.DEFAULT_SERVICE_PATH = 'booking-management';
BookableResourceBlockoutTypeService.BASE_PATH = 'api/bookable-resource-blockout-types';
//# sourceMappingURL=BookableResourceBlockoutTypeService.js.map